import { camelizeKeys } from '~/redux/api/transformers/utils';
import { managedEntities } from '~/services/serviceInstances';

import { GroupListServer } from './types';

export const getGroups = async ({
  offset,
  limit,
  search,
}: {
  offset?: number;
  limit?: number;
  search?: string;
} = {}) => {
  const response = await managedEntities.get<GroupListServer>('/groups', {
    params: {
      ...(offset && { 'page[offset]': offset }),
      ...(limit && { 'page[limit]': limit }),
      ...(search && { search }),
    },
  });

  return camelizeKeys(response);
};
